import { IComponent } from '@eventr/common'
import { Stack } from '@mui/material'
import { useParams } from 'react-router-dom'
import { useEditSectionContext } from '../../feat/editItinerary/editSectionProvider'
import { ComponentFinder } from '../componentFinder'
import { useScreenTypeContext } from '../state/screenTypeProvider'

interface IPushPathContainerProps {
    data: any
    renderOptions: IPushPathContainerOptions
    parentData?: any
    past?: boolean
}
interface IPushPathContainerOptions {
    components: IComponent[]
    direction?: 'row' | 'column'
    alignItems?: 'center' | 'flex-start' | 'flex-end'
    justifyContent?: 'center' | 'flex-start' | 'flex-end'
    visible?: string[]
    maxWidth?: string
    width?: string
    pageId?: string
}

export const PushPathContainer = ({
    data,
    renderOptions,
    parentData,
    past,
}: IPushPathContainerProps) => {
    const { screenType } = useScreenTypeContext()

    const { section } = useEditSectionContext()
    const { idItem } = useParams<{
        idItem: string
    }>()
    const path = () => {
        if (renderOptions.pageId) {
            return (
                '/edit/Section/' +
                section?.id +
                '/' +
                idItem +
                '/' +
                renderOptions.pageId +
                '/' +
                data._id
            )
        } else {
            return '/edit/Section/' + section?.id + '/' + data._id
        }
    }

    if (renderOptions.visible && !renderOptions.visible.includes(screenType)) {
        return null
    } else {
        return (
            <>
                {data && renderOptions.components && (
                    <Stack
                        alignItems={renderOptions.alignItems ?? 'center'}
                        direction={renderOptions.direction ?? 'row'}
                        justifyContent={
                            renderOptions.justifyContent ?? 'flex-start'
                        }
                        maxWidth={renderOptions.maxWidth ?? undefined}
                        width={renderOptions.width ?? undefined}
                        onClick={() => {
                            window.pushPath(path())
                        }}
                    >
                        {renderOptions.components.map((c, i) => {
                            return (
                                <ComponentFinder
                                    key={'finder_' + c.componentKey + i}
                                    data={data}
                                    renderOptions={c}
                                    componentKey={c.componentKey}
                                    parentData={parentData}
                                    isInPast={past}
                                />
                            )
                        })}
                    </Stack>
                )}
            </>
        )
    }
}
